<template>
    <div>
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Delete Incomplete Dataset?</h5>
                <button type="button" class="btn-close" @click="$emit('closeModal')" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p class="lead">This dataset is still processing, however issues can happen that can prevent completion. Please give the Dataset 30 min per 5000 records to fully complete. If this time has passed but the Dataset is still stuck 'Processing', then you should continue to delete the dataset. </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-lg btn-light" @click="$emit('closeModal')">Close</button>
                <button type="button" class="btn btn-lg btn-primary" @click="customDeleteDataset(String(this.passedModalData))">Continue to Delete Dataset</button>  
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
  name: 'ModalDeleteDataset',
  props: {
    passedModalData: '',
  },
  methods: {
        customDeleteDataset(filename) {
            axios.get('/remove_dataset', { params: {dataset: filename} })
            .then(
                    (response) => {
                this.$emit('messageAlert', {alert: 'Deleting selected Dataset.', classel: 'info'});
                this.returnUpdatedList();
                this.$emit('customChange', {shell: 'Datasets', dataset: ''});
                this.$emit('closeModal');
            }).catch(error => {
                this.errorMessage = error.message;
                this.$emit('messageAlert', {alert: 'There was an error!', classel: 'error'});
                console.error("There was an error!", error);
            });
        },
        returnUpdatedList() {
            axios({
                method : 'POST',
                url : '/list_datasets',
                data:'',
            }).then(response => this.datasets = processDatasets(response.data))
                .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
            });
        }
    }
}
function processDatasets(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        if (b[i].includes('scored-') || b[i].includes('prospect'))
          continue;
            iH.push(b[i]); 
      };
      return iH;
}
</script>